import React, { useState, useEffect, useContext, useRef } from "react";
import { styled } from "@mui/material/styles";
import { GridToolbarContainer, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import axios from "axios";
import "./../style.css";
import { Tooltip } from "@mui/material";
import LinkIcon from '@mui/icons-material/Link';
import { useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { Commonfun } from './../Commonfun';
import { AppContext } from "../../../Context/Context";
import { timezonechange } from './../Commonfun';
import { timezoneval } from './../Commonfun';
import GetAppIcon from '@mui/icons-material/GetApp';
import { useMediaQuery } from "react-responsive";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";
import DatagridComp from "../DatagridComp";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';



export default function PerformnceLevarageList() {

  const [cardData, setCardData] = useState([]);
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const [loading, setLoading] = useState(false);
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const navigate = useNavigate();
  const [jobDate, setJobdate] = React.useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [autoheightval, SetAutoheightval] = useState(true);
  const [tableLoading, setTableLoading] = useState(true);

  let querystring = useParams();
  let plag_id = querystring.id;
  const apihandleClose = () => {
    setapiOpen(false);
  };


  // const CustomToolbar = () => {
  //   return (
  //     <GridToolbarContainer style={{ display: "flex", justifyContent: "space-between", padding: "8px", alignItems: "end" }}>
  //       {/* <div className="below_note_ranking icon over_all_accessibility">
  //       </div> */}
  //       <div style={{ display: "flex", gap: "16px", alignItems: "center", justifyContent: "end", marginLeft: "auto", alignSelf: "center" }}>
  //         {/* <div onClick={handleModelPopUp} >
  //           <div className="dashboard_download" >
  //             Filter
  //             <svg
  //               className="filter"
  //               xmlns="http://www.w3.org/2000/svg"
  //               width="24"
  //               height="24"
  //               fill="none"
  //               stroke="currentColor"
  //               strokeWidth="2"
  //               strokeLinecap="round"
  //               strokeLinejoin="round"
  //               viewBox="0 0 24 24"
  //               style={{ cursor: "pointer" }}
  //             >
  //               <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  //             </svg>
  //           </div>
  //         </div> */}
  //         <div>
  //           <div
  //             ref={dropdownRef}
  //             style={{
  //               position: "relative",
  //               display: "inline-block",
  //               border: "1px solid #ff6600",
  //               borderRadius: "99rem",
  //             }}
  //           >
  //             <button
  //               className="dashboard_download"
  //               onClick={() => setDownload((prev) => !prev)}
  //             >
  //               Download{" "}
  //               <svg
  //                 className="filter"
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 width="24"
  //                 height="24"
  //                 fill="none"
  //                 stroke="currentColor"
  //                 strokeWidth="2"
  //                 strokeLinecap="round"
  //                 strokeLinejoin="round"
  //                 viewBox="0 0 24 24"
  //               >
  //                 <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
  //                 <polyline points="7 10 12 15 17 10" />
  //                 <line x1="12" y1="15" x2="12" y2="3" />
  //               </svg>
  //             </button>

  //             {download && (
  //               <div
  //                 className="download_dropdown"
  //                 style={{
  //                   position: "absolute",
  //                   top: "110%",
  //                   left: 0,
  //                   backgroundColor: "white",
  //                   boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
  //                   borderRadius: "4px",
  //                   minWidth: "150px",
  //                   zIndex: 1000,
  //                 }}
  //               >
  //                 <div
  //                   onClick={() => {
  //                     handleDownlodingPDF();
  //                     setDownload(false);
  //                   }}
  //                   onMouseOver={(e) =>
  //                     (e.currentTarget.style.backgroundColor = "#f5f5f5")
  //                   }
  //                   onMouseOut={(e) =>
  //                     (e.currentTarget.style.backgroundColor = "#fff")
  //                   }
  //                   style={menuItemStyle}
  //                 >
  //                   Download PDF
  //                 </div>

  //                 <div
  //                   onClick={() => {
  //                     handleDownlodingCSV();
  //                     setDownload(false);
  //                   }}
  //                   onMouseOver={(e) =>
  //                     (e.currentTarget.style.backgroundColor = "#f5f5f5")
  //                   }
  //                   onMouseOut={(e) =>
  //                     (e.currentTarget.style.backgroundColor = "#fff")
  //                   }
  //                   style={{ ...menuItemStyle, borderBottom: "none" }}
  //                 >
  //                   Download CSV
  //                 </div>
  //               </div>
  //             )}
  //           </div>
  //         </div>
  //       </div>
  //       <GridToolbarQuickFilter
  //         className="datagrid-search"
  //       />
  //     </GridToolbarContainer>
  //   );
  // };

  useEffect(() => {
    callUserdataApi();

  }, []);


  const columns = [
    // {
    //   field: "url",
    //   headerName: "Render Blocking",
    //   maxWidth: 600,
    //   flex: 1,
    //   headerAlign: "center",
    //   align: "center",
    //   sortable: false,
    //   description: "Resources that delay the display of a webpage's content.",
    //   headerClassName: "hide_option",
    //   disableClickEventBubbling: true,
    //   renderCell: (cardData) => {
    //     let firstEightLetters = cardData?.row?.url;
    //     let whoedata = firstEightLetters;

    //     let baseUrl = cardData?.row?.url.split("/").slice(0, 3).join("/") + "/";
    //     let remaining = cardData?.row?.url.split("/").slice(3).join("/");

    //     return (
    //       <>
    //         <Tooltip title={cardData.row.url}>
    //           <div className="prefered_url_external02">
    //             <a target="_blank" href={cardData?.row?.url} style={{ display: 'flex', flexDirection: 'column' }}>
    //               <span className="spanlink">
    //                 <LinkIcon /> {baseUrl}
    //               </span>
    //               <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word", width:"450px" }} >{remaining}</span>
    //             </a>
    //           </div>
    //         </Tooltip>

        
    //       </>
    //     );

    //   },
    // },

    {
      field: "url",
      headerName: "Render Blocking",
      minWidth: 380,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      description: "Resources that delay the display of a webpage's content.",
      disableClickEventBubbling: true,
      renderCell: (cardData) => {
        const url = cardData.row.url;
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");
        if (url !== null && url !== "") {
          return (
            <Tooltip title={url}>
              <div className="prefered_url_external02">
                <a className="table_links" href={url} target="_blank" rel="noopener noreferrer" style={{ display: 'flex', flexDirection: 'column' }}>
                  <span className="spanlink" style={{ color: "#044792" }} >
                    <LinkIcon /> {baseUrl}
                  </span>
                  <span className="spanlink" style={{ color: "#044792", wordWrap: "break-word", wordBreak: "break-word" }}>{remaining}</span>
                </a>
              </div>
            </Tooltip>
          );
        } else {
          return "-";
        }
      },
    },
    {
      field: "total_bytes",
      headerName: "Total Bytes",
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
      description: "Overall size of a resource.",
      disableClickEventBubbling: true,
    },
    {
      field: "wasted_bytes",
      headerName: "Wasted Bytes",
      minWidth: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      description: "Wasted bytes refer to unnecessary or redundant data transferred when loading a web page, which doesn't contribute to the user experience.",
      disableClickEventBubbling: true,
    },
  ];

  const rows = cardData ?? [];
  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);
    setCardData([]);


    const datavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}technical/v2/performance_leverage_browser_cache/?user_domain_id=${esodata.domaindata.value.header_selected}&link_id=${plag_id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      )
      .catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 400 || error?.response?.status == 500) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK" || error?.response?.status == 404) {
          navigate('/errorpages')
        }
      });

    const dataval = datavalue?.data?.leverage_data;

    if (dataval && dataval.length > 0) {
      const newData = dataval.map((obj, index) => {
        return { ...obj, sid: index + 1 };
      });

      setCardData(newData);
      SetAutoheightval(false);
    } else {
      SetAutoheightval(true);
    }
    setTableLoading(false);
    setLoading(false);
  };
  const pdfdown = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/performance_leverage_browser_cache/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&link_id=${plag_id}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("Performanceleverage", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();

        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);

  }

  const csvdown = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/v2/performance_leverage_browser_cache/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&link_id=${plag_id}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("Performanceleverage", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;

        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        toast.error("No Data", {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        console.error('Failed to fetch PDF:', response.status, response.statusText);
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
  }

  const [download, setDownload] = useState(false);
  const dropdownRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDownload(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const menuItemStyle = {
    padding: "10px 16px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    backgroundColor: "#fff",
    transition: "background 0.2s",
  };

  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }


  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Leverage Browser Cache Resources
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Content' },
                      { title: 'Performance', activeColor: true, link: '/performance' },
                      { title: 'Performance Detail', activeColor: true, link: '/performance' },
                      { title: 'Leverage Browser Cache Resources', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>
              <div className="time_zone">
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>

            </Grid>
          </Grid>
        </Box>
      </Container>

      {/* <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="">
                <DatagridComp
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={4}
                  customToolFunction={CustomToolbar}
                  tableLoading={tableLoading}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  customFilter={true}
                  DownloadShowFile={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container> */}

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                <DatagridComp
                  columns={columns}
                  rows={rows}
                  autoheightval={autoheightval}
                  datagridval={2}
                  tableLoading={tableLoading}
                  handleDownlodingCSV={handleDownlodingCSV}
                  handleDownlodingPDF={handleDownlodingPDF}
                  DownloadShowFile={true}
                  DownloadShowPDF={1}
                  DownloadShowCSV={2}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="footer-container">
        <Box className="footer-box">
          <Grid container className="footer-grid">
            <Grid item xs={12} md={6}>
              <div className="footer-left">
                <p className="footer-text">
                  All Rights Reserved Copyright © 2025 |
                  <a href="https://www.egrovesys.com/" target="blank">
                    <span className="footer-brand"> eGrove Systems</span>
                  </a>
                </p>
              </div>
            </Grid>
            <Grid item xs={12} md={6}>
              <div className="footer-right">
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>


      <div className="cnt_audit_outer_wrap">
        {/* <div className="top_breadcrumb_menu">
          <CommonBreadCrumb breadcrumbValue={[
            { title: 'Content' },
            { title: 'Performance', activeColor: true, link: '/performance' },
            { title: 'Performance Detail', activeColor: true, link: '/performance' },
            { title: 'Leverage Browser Cache Resources', activeColor: true }
          ]} />
          <div className="exportpdf_outer">

            <>
              <button className="exportpdf" alt="pdf icon" onClick={isDownloading ? null : pdfdown} title="PDF Download" ><GetAppIcon />PDF</button>
              <button className="exportpdf" alt="csv icon" onClick={isDownloadingcsv ? null : csvdown} title="CSV Download"  ><GetAppIcon />CSV</button>
            </>

          </div>
        </div>
        <div className="cnt_hdr_top_wraps">
          <div className="cnt_hdr_top_lft_wrap">
            <h2 className="heading_font" style={{ letterSpacing: "0.8px", fontWeight: 900, color: "#ff601f" }}>Leverage Browser Cache Resources</h2>
            <p style={{ fontSize: "14px", letterSpacing: "0.8px", color: "#ff601fc2" }}>as of {timezonechange(jobDate)}  <span style={{ fontWeight: 700 }}>  {timezoneval()} </span></p>

          </div>

        </div>
        <DatagridComp
          columns={columns}
          rows={rows}
          autoheightval={autoheightval}
          datagridval={4}
          customToolFunction={CustomToolbar}
          tableLoading={tableLoading}
        /> */}
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />
      </div>
    </div>
  );
}
